import { mediaAssets } from '#app/data/media-assets.generated.ts'

export const MEDIA_ORIGIN = 'https://media.dealerproedge.com'

export type MediaAssetPath = keyof typeof mediaAssets

function encodeObjectKey(key: string) {
	return key
		.replace(/^\/+/, '')
		.split('/')
		.map((segment) => {
			try {
				return encodeURIComponent(decodeURIComponent(segment))
			} catch {
				return encodeURIComponent(segment)
			}
		})
		.join('/')
}

export function mediaUrl(key: string) {
	return `${MEDIA_ORIGIN}/${encodeObjectKey(key)}`
}

export function mediaAsset(logicalPath: MediaAssetPath | string) {
	const normalizedPath = logicalPath.startsWith('/')
		? logicalPath
		: `/${logicalPath}`
	const entry = mediaAssets[normalizedPath as MediaAssetPath]

	if (!entry) {
		throw new Error(`Unknown media asset: ${normalizedPath}`)
	}

	return `${mediaUrl(entry.key)}?v=${entry.sha256}`
}

export function isMediaAsset(logicalPath: string): logicalPath is MediaAssetPath {
	const normalizedPath = logicalPath.startsWith('/')
		? logicalPath
		: `/${logicalPath}`
	return normalizedPath in mediaAssets
}
